module.exports = __webpack_public_path__ + "img/premio-02.a1ca0c0b.png";